module.exports = __webpack_public_path__ + "static/media/chat.54c3a15d.svg";